export type AppEnv =
  | "local"
  | "develop"
  | "demo"
  | "production"
  | "staging0"
  | "staging1"
  | "staging2"
  | "staging3"
  | "staging6"
  | "staging8";

export const appEnv = process.env.NEXT_PUBLIC_APP_ENV as AppEnv;
